import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const WHATSAPP_NUMBER = "917425985850";
export const PHONE_DISPLAY = "+91 74259 85850";
export const PHONE_TEL = "+917425985850";
export const EMAIL = "cabjodhpur93@gmail.com";
export const LOGO_URL = "/assets/logo.webp";

// Capture UTM / Google Ads params from the URL so we can attribute leads.
export function getTracking() {
  if (typeof window === "undefined") return {};
  const params = new URLSearchParams(window.location.search);
  const pick = (k) => params.get(k) || undefined;
  return {
    utm_source: pick("utm_source"),
    utm_medium: pick("utm_medium"),
    utm_campaign: pick("utm_campaign"),
    utm_term: pick("utm_term"),
    utm_content: pick("utm_content"),
    gclid: pick("gclid"),
    referrer: document.referrer || undefined,
    page_url: window.location.href,
  };
}

export function buildWhatsAppMessage(form) {
  const lines = [
    "Namaste Jodhpur Cabs! I'd like to book a taxi.",
    "",
    `Name: ${form.name || "-"}`,
    `Phone: ${form.phone || "-"}`,
    `Trip: ${form.trip_type || "-"}`,
    `Pickup: ${form.pickup || "-"}`,
    `Drop: ${form.drop || "-"}`,
    `Date: ${form.date || "-"}`,
    `Car: ${form.car || "-"}`,
  ];
  return lines.join("\n");
}

export function whatsappUrl(text) {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
}

// Save lead to backend (best-effort) then open WhatsApp.
export async function submitLead(form) {
  const tracking = getTracking();
  const payload = { ...form, ...tracking };
  try {
    await axios.post(`${API}/leads`, payload);
  } catch (e) {
    // Non-blocking: still proceed to WhatsApp even if logging fails.
    console.error("lead save failed", e);
  }
  const url = whatsappUrl(buildWhatsAppMessage(form));
  window.open(url, "_blank", "noopener,noreferrer");
  return true;
}
